/**
 * Application Expired dialog – shown when status is EXPIRED.
 * Message: expired due to inactivity; if less than 30 days they can contact Liberty to unexpire.
 * Based on workflow: 3.3 Applicant / Resident Panel – When status is EXPIRED
 */

import { ConfirmDialog } from '@/components/ui/ConfirmDialog'
import { applicantConfirmDialogProps } from '@/features/applicant/constants/applicantDialogProps'
import type { ExpiredApplicationDialogProps } from '@/features/applicant/types/components'

export function ExpiredApplicationDialog({
  open,
  onClose,
  contactEmail,
}: ExpiredApplicationDialogProps) {
  const email = contactEmail || 'help@libertyrent.com'
  const mailto = `mailto:${email}?subject=Application%20Expired%20-%20Request%20to%20Unexpire`

  const message =
    'Your application has been expired, due to inactivity.\n\n' +
    'If your application is less than 30 days old, you can contact Liberty Customer Service to unexpire it if you want to continue to complete your application.\n\n' +
    `Contact ${email} or (877) 581-7368.`

  return (
    <ConfirmDialog
      {...applicantConfirmDialogProps}
      isOpen={open}
      title="Application Expired"
      message={message}
      primaryLabel="Yes"
      onPrimary={onClose}
      secondaryLabel="Contact Us"
      onSecondary={() => {
        window.location.href = mailto
      }}
      onDismiss={onClose}
      overlayDataTestId="applicant-modal-expired"
      primaryButtonDataTestId="applicant-modal-expired-yes-btn"
      secondaryButtonDataTestId="applicant-modal-expired-contact-link"
      closeButtonDataTestId="applicant-modal-expired-close-btn"
    />
  )
}
